import { Controller } from '@hotwired/stimulus';
export default class extends Controller {
  initialize() {}

  connect() {}

  static targets = ['content', 'trigger', 'icon'];
  static values = {
    isOpen: Boolean,
  };

  toggleIsOpen() {
    this.isOpenValue = !this.isOpenValue;
  }

  toggle(e) {
    this.toggleIsOpen();
    this.toggleContent();
    this.toggleTrigger();
    this.toggleIcon();
  }

  toggleContent() {
    this.contentTarget.classList.toggle(
      'grid-rows-1fr',
      this.isOpenValue
    );
    this.contentTarget.children[0].classList.toggle(
      'opacity-0',
      !this.isOpenValue
    );
    // this.contentTarget.children[0].classList.toggle(
    //   'overflow-hidden',
    //   !this.isOpenValue
    // );
  }

  toggleTrigger() {
    this.triggerTarget.setAttribute(
      'aria-expanded',
      this.isOpenValue
    );
  }

  toggleIcon() {
    this.iconTarget.classList.toggle('rotate-180', !this.isOpenValue);
  }
}
